export default __webpack_public_path__ + "static/automate-do-2-f84f51c421cdb08fcfc3cad1ccf3b221.png";